import styled from "styled-components";

export const Card = styled.div`
    border-radius: 8px;
    background-color: ${p => p.theme.c.cardBackground};
    box-shadow: 0 0 12px 0 ${p => p.theme.c.blackShadow1};
    padding: 16px;
    margin-top: 56px;
    margin-bottom: 18px;
    position: sticky;
    top: 110px;

    h4 {
        font-size: 20px;
        color: ${p => p.theme.c.active};
        text-align: center;
        font-weight: 600;
        margin-bottom: 16px;
    }

    p {
        font-size: 16px;
        color: ${p => p.theme.c.grey5};
        text-align: center;
    }

    button {
        margin: auto;
        display: block;
        margin-bottom: 0;
        padding-left: 32px;
        padding-right: 32px;
    }
`;

export const IconWrapper = styled.div`
    position: absolute;
    top: -36px;
    height: 72px;
    width: 72px;
    border-radius: 36px;
    background-color: ${p => p.theme.c.active};
    box-shadow: 0 0 0 4px ${p => p.theme.c.boost} inset;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    align-items: center;
    justify-content: center;

    .i-donate {
        font-size: 48px;
        color: ${p => p.theme.c.info};
    }
`;
